// Sportpacks Redesign - (c) 2026 NextPercent, nextpercent.de
// Lizenziert ausschliesslich fuer sport-packs.myshopify.com.
// Einsatz in weiteren Shops nur mit schriftlicher Genehmigung: info@nextpercent.de
// Do not hide or replay images: native image loading preserves stable paint.
// Keep Klaviyo's own variant availability and click handler intact.
(() => {
  const product = document.querySelector('.sp-product');
  if (!product) return;
  let queued = false;
  function positionRestock() {
    queued = false;
    const submit = product.querySelector('.product-form__submit');
    const trigger = product.querySelector('.sp-restock-trigger');
    if (submit && trigger && submit.nextElementSibling !== trigger) submit.after(trigger);
  }
  new MutationObserver(() => {
    if (!queued) { queued = true; requestAnimationFrame(positionRestock); }
  }).observe(product, { childList: true, subtree: true });
  positionRestock();
})();
